// extracted by mini-css-extract-plugin
export default {"message-toast":"MessageToast_message-toast__cgjzB"};